module.exports = __webpack_public_path__ + "static/media/Fb.65187dd6.svg";